<template>
  <modal-layout>
    <popup-terms @dispose="onDispose">
      <slot />
    </popup-terms>
  </modal-layout>
</template>

<script>
import ModalLayout from '@/components/global/ModalLayout.vue';
import modalMixin from '@/components/global/modal-mixin';
import PopupTerms from '@/components/modal-popups/PopupTerms.vue';

export default {
  name: 'ModalTerms',
  components: {
    ModalLayout,
    PopupTerms,
  },
  mixins: [modalMixin],
  data() {
    return {
      temp: false,
    };
  },
};
</script>

<style>

</style>
